import Order from '../order/Order';

export default function MyOrders() {
  return <Order />;
}
